import {logPageTime} from './src/lowPrice/common/utils';
import {isWx} from './src/lowPrice/common/hysdkUtils/env';

// wx jssdk
if (isWx() && typeof window.wx === 'undefined') {
    document.write('<script src="//res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>');
}

// godeye
require('@qnpm/godeye');

// headtime: HTML Head区域加载完的时间
logPageTime({r: 'headtime', time: window.__start_time - window.__root_time});

// if (!window.hysdk || !window.hysdk.isInit) {
//     require('@qnpm/hysdk');
//     require('@qnpm/hysdk-qunar');
//
//     hysdk && hysdk.config({
//         'debug': false, /* 调试开关 */
//         'bridgeReadyEvent': 'WebViewJavascriptBridgeReady', /* Hytive 桥 Ready 事件 */
//         'bridgeReadyTimeout': 600, /* 桥 Ready 最大延迟 */
//         'hytiveReg': '', /* Hytive UA 判断正则 */
//         'wechatSupport': false /* 是否支持微信 */ /* qunar/fusion 版本默认为 true，使用去哪儿网公共号 */
//     });
// }


// hysdk
hysdk.hideLoadView();
hysdk.ready(() => {
    // Webview设置
    hysdk.setWebViewAttr({
        // webView是否可以滚动
        scrollEnabled: false, // 是否允许native滚动（Android无效）
        // iOS滑动出document区域，展示出的背景颜色
        backgroundColor: 'red', // Hytive 1.0 webview的背景颜色（Android无效）
        name: 'lowFlightList', // Hytive 1.0
        bounces: 'true' // webview的弹性效果
    });

});

hysdk.app.setStatusBarStyle({
    color: 'dark',
    success: function() {
    }
});

// rn Ext
Ext.defaults.hybridId = 'low_price_rn';
Ext.defaults.indexView = 'HomeView';

// loadtime: JS逻辑开始执行时间
logPageTime({r: 'loadtime',  time: new Date().getTime() - window.__root_time});

